export default "__VITE_ASSET__DaTDSUgq__";